function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarDrivingStatic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M692.76,364.88c17.27-32,19.82-68.47,15.77-103.71-3.59-31.26-9-67.12-24.17-95.33C646,94.36,548.89,60.81,470.07,82.3c-32.88,9-55.94,29.75-82.33,49.53-19.52,14.62-40.93,28.89-66.15,31.81-60.39,7-129.12-50-186.39-45s-102,56-104.13,100,41.65,89,37.49,119-31.24,110,76,113,163.48-57,205.14-44,133.28,51,210.33,41c50.27-6.53,99.42-31.21,127-73.15Q690.13,369.78,692.76,364.88Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.76,364.88c17.27-32,19.82-68.47,15.77-103.71-3.59-31.26-9-67.12-24.17-95.33C646,94.36,548.89,60.81,470.07,82.3c-32.88,9-55.94,29.75-82.33,49.53-19.52,14.62-40.93,28.89-66.15,31.81-60.39,7-129.12-50-186.39-45s-102,56-104.13,100,41.65,89,37.49,119-31.24,110,76,113,163.48-57,205.14-44,133.28,51,210.33,41c50.27-6.53,99.42-31.21,127-73.15Q690.13,369.78,692.76,364.88Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M727,468.33H27.81a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H727a.5.5,0,0,1,.5.5A.5.5,0,0,1,727,468.33Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322,56.74H235.57l2.23-3c1.17-1.55,2.94-1.54,4.23-1.53a3.27,3.27,0,0,0,1.59-.21,5.82,5.82,0,0,0,.92-1.28,15.2,15.2,0,0,1,5.65-5.82c2.55-1.5,5.28-1,7.27-.6s2.86.46,3.11-.46c1-3.69,3.53-7.43,7.62-6.89a25.53,25.53,0,0,1,3.52.82c3.45,1,5.61,1.41,6.56-.79,1.65-3.87,4.78-8.81,12.8-7.09,7.69,1.64,11,10.06,11.23,10.63,1.64,3.51,4.76,3.2,8.38,2.83,3.14-.31,6.39-.64,8.9,1.61,5.38,4.81,2.6,11.39,2.57,11.45Zm-84.45-1h83.78a9.09,9.09,0,0,0-2.44-10c-2.18-2-5.2-1.66-8.13-1.36-3.67.37-7.46.75-9.39-3.43l0,0c0-.09-3.26-8.47-10.51-10s-10,2.67-11.67,6.51c-1.36,3.17-4.61,2.25-7.75,1.37a26.28,26.28,0,0,0-3.39-.8c-4.33-.57-6.09,4.57-6.52,6.16-.52,1.9-2.33,1.55-4.25,1.18s-4.36-.83-6.58.48a14.39,14.39,0,0,0-5.31,5.47,5.68,5.68,0,0,1-1.17,1.57,3.64,3.64,0,0,1-2.2.41c-1.25,0-2.56,0-3.42,1.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572,76.48H421.33l3.46-4.62c1.93-2.56,4.8-2.54,7.11-2.53a5.61,5.61,0,0,0,3-.43,9.67,9.67,0,0,0,1.72-2.36,26.26,26.26,0,0,1,9.78-10.07c4.35-2.56,8.87-1.7,12.5-1s5.33.92,5.87-1.08c1.73-6.32,6-12.74,13-11.81A45,45,0,0,1,483.86,44c5.39,1.52,10.05,2.83,12-1.61,2.85-6.66,8.25-15.17,22-12.22C531.1,33,537,48,537.29,48.59c3,6.43,8.85,5.84,15.08,5.21,5.43-.55,11-1.11,15.32,2.73,9.23,8.25,4.47,19.54,4.42,19.65Zm-148.65-1h148C572,73.67,575,64.4,567,57.27c-4-3.54-9.35-3-14.56-2.47-6.31.63-12.83,1.29-16.1-5.8v0c-.06-.15-5.79-15-18.72-17.81s-18,4.76-20.9,11.63c-2.26,5.26-7.8,3.69-13.15,2.18a45.71,45.71,0,0,0-6-1.4c-7.92-1.06-11.07,8.22-11.85,11.08s-3.69,2.44-7,1.8-7.78-1.48-11.8.89a25.52,25.52,0,0,0-9.44,9.72,9.73,9.73,0,0,1-2,2.65c-.86.65-2.13.64-3.61.63-2.2,0-4.68,0-6.31,2.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.93,85.86h-60l1.72-2.3a3.4,3.4,0,0,1,3-1.12,2.26,2.26,0,0,0,1-.11,3.66,3.66,0,0,0,.6-.84,10.6,10.6,0,0,1,3.95-4.06,7,7,0,0,1,5.12-.43c1.5.28,1.83.25,2-.21.71-2.6,2.51-5.25,5.42-4.86a18.07,18.07,0,0,1,2.45.57c2.29.65,3.72,1,4.34-.46,1.16-2.72,3.36-6.19,9-5,5.35,1.15,7.68,7,7.85,7.42,1.08,2.32,3.18,2.1,5.62,1.86,2.09-.21,4.46-.45,6.25,1.15,3.78,3.39,1.83,8,1.81,8.07Zm-58-1h57.32a6.12,6.12,0,0,0-1.67-6.63c-1.45-1.3-3.41-1.1-5.48-.89-2.59.25-5.26.52-6.64-2.46v0c0-.06-2.22-5.76-7.13-6.81s-6.77,1.8-7.88,4.39c-1,2.31-3.4,1.63-5.52,1a17.8,17.8,0,0,0-2.31-.54c-2.86-.39-4,3.07-4.33,4.13-.39,1.45-1.77,1.18-3.11.93a6.15,6.15,0,0,0-4.43.31,9.76,9.76,0,0,0-3.6,3.72,3.83,3.83,0,0,1-.85,1.12,2.59,2.59,0,0,1-1.6.31,2.48,2.48,0,0,0-2.24.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596,111.41H536l1.72-2.3a3.4,3.4,0,0,1,3-1.12,2.29,2.29,0,0,0,1-.1,4.13,4.13,0,0,0,.6-.85,10.63,10.63,0,0,1,3.94-4.06,7,7,0,0,1,5.13-.43c1.5.29,1.83.25,2-.21.71-2.6,2.49-5.25,5.42-4.86a18.42,18.42,0,0,1,2.45.57c2.29.65,3.72,1,4.33-.46,1.17-2.71,3.36-6.19,9-5,5.36,1.15,7.69,7,7.86,7.42,1.08,2.32,3.18,2.11,5.61,1.86,2.1-.21,4.47-.45,6.26,1.15,3.78,3.39,1.83,8,1.81,8.07Zm-58-1h57.32a6.12,6.12,0,0,0-1.67-6.63c-1.46-1.3-3.41-1.1-5.49-.89-2.58.26-5.25.53-6.63-2.46v0c0-.06-2.22-5.76-7.14-6.81s-6.76,1.8-7.87,4.39c-1,2.31-3.4,1.63-5.52,1a17.8,17.8,0,0,0-2.31-.54c-2.86-.38-4,3.07-4.33,4.14-.39,1.44-1.77,1.17-3.11.92a6.15,6.15,0,0,0-4.43.31,9.76,9.76,0,0,0-3.6,3.72,4,4,0,0,1-.85,1.13,2.58,2.58,0,0,1-1.6.3,2.51,2.51,0,0,0-2.24.72Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--City--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M671.9,317.45a.5.5,0,0,1-.5-.5V102.09H625.92V208.66h-20V137.37H573.82V246.15H554.51V181.47H540.72v67.62H530.57V185H518.19v64.08H497.47v-9.56H465.9V156.67H415.38V238.8H335.51V101.35H278.77v61H244V91.68H190.75V252.76H177.08v-83h-48.3V211.6h-26v89.68H72.65a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h29.08V210.6h26.05V168.71h50.3v83h11.67V90.68H245v70.68h32.8v-61h58.74V237.8h77.87V155.67H466.9v82.86h31.57v9.56h18.72V184h14.38v64.08h8.15V180.47h15.79v64.68h17.31V136.37h34.09v71.29h18V101.09H672.4V317A.5.5,0,0,1,671.9,317.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.11,233.65h-6.63V225.3h6.63Zm-5.63-1h4.63V226.3h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26,233.65h-6.63V225.3h6.63Zm-5.63-1h4.63V226.3h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.42,233.65h-6.64V225.3h6.64Zm-5.64-1h4.64V226.3h-4.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.57,233.65h-6.63V225.3h6.63Zm-5.63-1h4.63V226.3h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.73,233.65h-6.64V225.3h6.64Zm-5.64-1h4.64V226.3h-4.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.88,233.65h-6.63V225.3h6.63Zm-5.63-1h4.63V226.3h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.83,179.26H198.2v-8.35h6.63Zm-5.63-1h4.63v-6.35H199.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,179.26h-6.64v-8.35H214Zm-5.64-1H213v-6.35h-4.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.14,179.26h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.3,179.26h-6.64v-8.35h6.64Zm-5.64-1h4.64v-6.35h-4.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.83,166H198.2v-8.35h6.63Zm-5.63-1h4.63v-6.35H199.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,166h-6.64v-8.35H214Zm-5.64-1H213v-6.35h-4.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.14,166h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.3,166h-6.64v-8.35h6.64Zm-5.64-1h4.64v-6.35h-4.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.83,152.8H198.2v-8.35h6.63Zm-5.63-1h4.63v-6.35H199.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,152.8h-6.64v-8.35H214Zm-5.64-1H213v-6.35h-4.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.14,152.8h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.3,152.8h-6.64v-8.35h6.64Zm-5.64-1h4.64v-6.35h-4.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.83,139.57H198.2v-8.35h6.63Zm-5.63-1h4.63v-6.35H199.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,139.57h-6.64v-8.35H214Zm-5.64-1H213v-6.35h-4.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.14,139.57h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.3,139.57h-6.64v-8.35h6.64Zm-5.64-1h4.64v-6.35h-4.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.83,126.34H198.2V118h6.63Zm-5.63-1h4.63V119H199.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,126.34h-6.64V118H214Zm-5.64-1H213V119h-4.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.14,126.34h-6.63V118h6.63Zm-5.63-1h4.63V119h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.3,126.34h-6.64V118h6.64Zm-5.64-1h4.64V119h-4.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.45,179.26h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.6,179.26H244v-8.35h6.63Zm-5.63-1h4.63v-6.35H245Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.83,194H198.2v-8.35h6.63Zm-5.63-1h4.63v-6.35H199.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,194h-6.64v-8.35H214Zm-5.64-1H213v-6.35h-4.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.14,194h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.3,194h-6.64v-8.35h6.64Zm-5.64-1h4.64v-6.35h-4.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.45,194h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.6,194H244v-8.35h6.63ZM245,193h4.63v-6.35H245Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.11,249.09h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26,249.09h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.42,249.09h-6.64v-8.35h6.64Zm-5.64-1h4.64v-6.35h-4.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.57,249.09h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.73,249.09h-6.64v-8.35h6.64Zm-5.64-1h4.64v-6.35h-4.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.88,249.09h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.11,264.53h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26,264.53h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.42,264.53h-6.64v-8.35h6.64Zm-5.64-1h4.64v-6.35h-4.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.57,264.53h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.73,264.53h-6.64v-8.35h6.64Zm-5.64-1h4.64v-6.35h-4.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.88,264.53h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.11,280h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26,280h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.42,280h-6.64v-8.35h6.64Zm-5.64-1h4.64v-6.35h-4.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.57,280h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.73,280h-6.64v-8.35h6.64Zm-5.64-1h4.64v-6.35h-4.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.88,280h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.11,295.4h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26,295.4h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.42,295.4h-6.64v-8.35h6.64Zm-5.64-1h4.64v-6.35h-4.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.57,295.4h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.73,295.4h-6.64v-8.35h6.64Zm-5.64-1h4.64v-6.35h-4.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.88,295.4h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.16,124.87h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.32,124.87h-6.64v-8.35h6.64Zm-5.64-1h4.64v-6.35h-4.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.47,124.87h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.16,143.25h-6.63V134.9h6.63Zm-5.63-1h4.63V135.9h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.32,143.25h-6.64V134.9h6.64Zm-5.64-1h4.64V135.9h-4.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.47,143.25h-6.63V134.9h6.63Zm-5.63-1h4.63V135.9h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.16,161.62h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.32,161.62h-6.64v-8.35h6.64Zm-5.64-1h4.64v-6.35h-4.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.47,161.62h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.16,180h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.32,180h-6.64v-8.35h6.64Zm-5.64-1h4.64v-6.35h-4.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.47,180h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.16,198.37h-6.63V190h6.63Zm-5.63-1h4.63V191h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.32,198.37h-6.64V190h6.64Zm-5.64-1h4.64V191h-4.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.47,198.37h-6.63V190h6.63Zm-5.63-1h4.63V191h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.16,216.75h-6.63V208.4h6.63Zm-5.63-1h4.63V209.4h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.32,216.75h-6.64V208.4h6.64Zm-5.64-1h4.64V209.4h-4.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.47,216.75h-6.63V208.4h6.63Zm-5.63-1h4.63V209.4h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.16,235.12h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.32,235.12h-6.64v-8.35h6.64Zm-5.64-1h4.64v-6.35h-4.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.47,235.12h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.16,253.5h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.32,253.5h-6.64v-8.35h6.64Zm-5.64-1h4.64v-6.35h-4.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.47,253.5h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.16,271.88h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.32,271.88h-6.64v-8.35h6.64Zm-5.64-1h4.64v-6.35h-4.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.23,161.62H582.6v-8.35h6.63Zm-5.63-1h4.63v-6.35H583.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.38,161.62h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.23,180H582.6v-8.35h6.63Zm-5.63-1h4.63v-6.35H583.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.38,180h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.23,198.37H582.6V190h6.63Zm-5.63-1h4.63V191H583.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.38,198.37h-6.63V190h6.63Zm-5.63-1h4.63V191h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.23,216.75H582.6V208.4h6.63Zm-5.63-1h4.63V209.4H583.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.38,216.75h-6.63V208.4h6.63Zm-5.63-1h4.63V209.4h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.23,235.12H582.6v-8.35h6.63Zm-5.63-1h4.63v-6.35H583.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.38,235.12h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.23,253.5H582.6v-8.35h6.63Zm-5.63-1h4.63v-6.35H583.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.38,253.5h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.23,271.88H582.6v-8.35h6.63Zm-5.63-1h4.63v-6.35H583.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.38,271.88h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.89,180h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.05,180h-6.64v-8.35h6.64Zm-5.64-1h4.64v-6.35h-4.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.89,198.37h-6.63V190h6.63Zm-5.63-1h4.63V191h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.05,198.37h-6.64V190h6.64Zm-5.64-1h4.64V191h-4.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.89,216.75h-6.63V208.4h6.63Zm-5.63-1h4.63V209.4h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.05,216.75h-6.64V208.4h6.64Zm-5.64-1h4.64V209.4h-4.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.89,235.12h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.05,235.12h-6.64v-8.35h6.64Zm-5.64-1h4.64v-6.35h-4.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.89,253.5h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.05,253.5h-6.64v-8.35h6.64Zm-5.64-1h4.64v-6.35h-4.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.89,271.88h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.05,271.88h-6.64v-8.35h6.64Zm-5.64-1h4.64v-6.35h-4.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.62,180H442v-8.35h6.63ZM443,179h4.63v-6.35H443Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.78,180h-6.64v-8.35h6.64Zm-5.64-1h4.64v-6.35h-4.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.62,198.37H442V190h6.63Zm-5.63-1h4.63V191H443Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.78,198.37h-6.64V190h6.64Zm-5.64-1h4.64V191h-4.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.62,216.75H442V208.4h6.63Zm-5.63-1h4.63V209.4H443Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.78,216.75h-6.64V208.4h6.64Zm-5.64-1h4.64V209.4h-4.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.62,235.12H442v-8.35h6.63Zm-5.63-1h4.63v-6.35H443Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.78,235.12h-6.64v-8.35h6.64Zm-5.64-1h4.64v-6.35h-4.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.62,253.5H442v-8.35h6.63Zm-5.63-1h4.63v-6.35H443Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.78,253.5h-6.64v-8.35h6.64Zm-5.64-1h4.64v-6.35h-4.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.62,271.88H442v-8.35h6.63Zm-5.63-1h4.63v-6.35H443Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.78,271.88h-6.64v-8.35h6.64Zm-5.64-1h4.64v-6.35h-4.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.73,124.87H298.1v-8.35h6.63Zm-5.63-1h4.63v-6.35H299.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.88,124.87h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.73,143.25H298.1V134.9h6.63Zm-5.63-1h4.63V135.9H299.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.88,143.25h-6.63V134.9h6.63Zm-5.63-1h4.63V135.9h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.73,161.62H298.1v-8.35h6.63Zm-5.63-1h4.63v-6.35H299.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.88,161.62h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.73,180H298.1v-8.35h6.63Zm-5.63-1h4.63v-6.35H299.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.88,180h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.73,198.37H298.1V190h6.63Zm-5.63-1h4.63V191H299.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.88,198.37h-6.63V190h6.63Zm-5.63-1h4.63V191h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.73,216.75H298.1V208.4h6.63Zm-5.63-1h4.63V209.4H299.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.88,216.75h-6.63V208.4h6.63Zm-5.63-1h4.63V209.4h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.73,235.12H298.1v-8.35h6.63Zm-5.63-1h4.63v-6.35H299.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.88,235.12h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.73,253.5H298.1v-8.35h6.63Zm-5.63-1h4.63v-6.35H299.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.88,253.5h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.73,271.88H298.1v-8.35h6.63Zm-5.63-1h4.63v-6.35H299.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.88,271.88h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.47,271.88h-6.63v-8.35h6.63Zm-5.63-1h4.63v-6.35h-4.63Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Trees--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M647.27,383.19c0,28.05-15.73,30.17-35.13,30.17S577,411.24,577,383.19s15.73-86.69,35.14-86.69S647.27,355.14,647.27,383.19Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.27,383.19c0,28.05-15.73,30.17-35.13,30.17S577,411.24,577,383.19s15.73-86.69,35.14-86.69S647.27,355.14,647.27,383.19Z",
    style: {
      fill: "#fff",
      opacity: 0.58
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "624.01 395.92 618.2 396.32 633.34 386.12 622.53 391.58 624.01 387.31 619.07 393.33 613.27 396.26 612.82 376.11 615.88 368.66 612.74 372.85 612.47 361.17 622.1 348.33 612.41 358.26 611.82 332.55 611.3 349 605.12 342.11 611.2 352.17 610.38 378.23 605 374.71 600.1 366.03 602.07 372.79 592.45 366.51 610.26 381.87 607.57 467.42 614.9 467.42 613.35 399.59 615.05 398.45 624.01 395.92",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.82,332c0,45.11-25.3,48.51-56.5,48.51s-56.5-3.4-56.5-48.51,25.3-139.41,56.5-139.41S733.82,286.87,733.82,332Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.82,332c0,45.11-25.3,48.51-56.5,48.51s-56.5-3.4-56.5-48.51,25.3-139.41,56.5-139.41S733.82,286.87,733.82,332Z",
    style: {
      fill: "#fff",
      opacity: 0.31
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "696.42 352.45 687.08 353.09 711.42 336.68 694.03 345.47 696.42 338.6 688.48 348.28 679.15 352.99 678.41 320.6 683.35 308.61 678.29 315.35 677.86 296.57 693.35 275.93 677.76 291.89 676.81 250.55 675.98 277.01 666.04 265.93 675.82 282.09 674.5 324 665.85 318.35 657.97 304.38 661.13 315.26 645.66 305.15 674.31 329.86 669.97 467.42 681.77 467.42 679.27 358.35 682 356.51 696.42 352.45",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.25,383.19c0,28.05,15.73,30.17,35.14,30.17s35.13-2.12,35.13-30.17-15.73-86.69-35.13-86.69S112.25,355.14,112.25,383.19Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.25,383.19c0,28.05,15.73,30.17,35.14,30.17s35.13-2.12,35.13-30.17-15.73-86.69-35.13-86.69S112.25,355.14,112.25,383.19Z",
    style: {
      fill: "#fff",
      opacity: 0.58
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.51 395.92 141.32 396.32 126.18 386.12 136.99 391.58 135.51 387.31 140.45 393.33 146.25 396.26 146.71 376.11 143.64 368.66 146.78 372.85 147.05 361.17 137.42 348.33 147.12 358.26 147.7 332.55 148.22 349 154.4 342.11 148.32 352.17 149.15 378.23 154.52 374.71 159.42 366.03 157.46 372.79 167.07 366.51 149.26 381.87 151.96 467.42 144.62 467.42 146.17 399.59 144.48 398.45 135.51 395.92",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.08,332.43c0,45,25.21,48.35,56.31,48.35s56.31-3.39,56.31-48.35S113.49,193.49,82.39,193.49,26.08,287.47,26.08,332.43Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.08,332.43c0,45,25.21,48.35,56.31,48.35s56.31-3.39,56.31-48.35S113.49,193.49,82.39,193.49,26.08,287.47,26.08,332.43Z",
    style: {
      fill: "#fff",
      opacity: 0.31
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.35 352.83 72.67 353.47 48.41 337.12 65.73 345.88 63.35 339.03 71.28 348.68 80.57 353.37 81.3 321.09 76.38 309.14 81.42 315.86 81.85 297.14 66.42 276.56 81.96 292.47 82.9 251.27 83.73 277.64 93.63 266.6 83.89 282.71 85.21 324.48 93.83 318.84 101.68 304.93 98.53 315.77 113.94 305.69 85.39 330.32 89.72 467.42 77.96 467.42 80.44 358.71 77.73 356.88 63.35 352.83",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Characters--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 360.07,
    y: 209.24,
    width: 38.79,
    height: 15.61,
    rx: 3.99,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.87,225.35H364.06a4.5,4.5,0,0,1-4.49-4.49v-7.62a4.5,4.5,0,0,1,4.49-4.5h30.81a4.5,4.5,0,0,1,4.49,4.5v7.62A4.49,4.49,0,0,1,394.87,225.35Zm-30.81-15.61a3.5,3.5,0,0,0-3.49,3.5v7.62a3.49,3.49,0,0,0,3.49,3.49h30.81a3.49,3.49,0,0,0,3.49-3.49v-7.62a3.5,3.5,0,0,0-3.49-3.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.15,
    y: 201.67,
    width: 3.78,
    height: 11.83,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.94,214h-3.79a.5.5,0,0,1-.5-.5V201.67a.51.51,0,0,1,.5-.5h3.79a.51.51,0,0,1,.5.5V213.5A.5.5,0,0,1,379.94,214Zm-3.29-1h2.79V202.17h-2.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.8,286.47,499.24,276l-18.91-69.86-31.46-3.88,13.61,50.56H303.37L317,202.21l-31.46,3.88L266.34,277,252,286.47Zm-60-80.38,23.7,1.72L491.61,270l-22.26-17.27h-1.2ZM289.4,207.81l23.7-1.72-16.59,50.3.56.19-23.32,15.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.8,287H252a.5.5,0,0,1-.28-.91l14.17-9.4L285,206a.5.5,0,0,1,.42-.37l31.46-3.88a.52.52,0,0,1,.44.17.48.48,0,0,1,.1.46L304,252.27H461.83l-13.44-49.93a.48.48,0,0,1,.1-.46.56.56,0,0,1,.44-.17l31.46,3.88a.52.52,0,0,1,.43.37l18.86,69.7,13.43,10.42a.49.49,0,0,1-.31.89Zm-259.13-1H511.34l-12.41-9.62a.44.44,0,0,1-.17-.27l-18.82-69.54-30.39-3.74L463,252.64a.5.5,0,0,1-.08.43.52.52,0,0,1-.4.2H303.37a.52.52,0,0,1-.4-.2.5.5,0,0,1-.08-.43l13.42-49.84-30.4,3.74L266.82,277.1a.47.47,0,0,1-.21.29Zm20.08-13.41a.46.46,0,0,1-.29-.1.48.48,0,0,1-.2-.52l15.65-64.25a.5.5,0,0,1,.45-.38l23.71-1.72a.5.5,0,0,1,.51.66l-16.44,49.83.09,0a.51.51,0,0,1,.34.41.5.5,0,0,1-.22.48L274,272.47A.46.46,0,0,1,273.75,272.56Zm16.05-64.28-15.26,62.65,21.54-14.28a.47.47,0,0,1-.05-.42l16.36-49.59Zm201.81,62.26a.51.51,0,0,1-.31-.11l-22.13-17.16h-1a.5.5,0,0,1-.48-.35l-15.4-46.67a.5.5,0,0,1,.51-.66l23.71,1.72a.5.5,0,0,1,.45.38l15.16,62.23a.51.51,0,0,1-.22.54A.5.5,0,0,1,491.61,270.54Zm-23.1-18.27h.84a.47.47,0,0,1,.3.1l21.14,16.39-14.74-60.48-22.59-1.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.11,289.66l-2.33-33.27a15.09,15.09,0,0,0-15-14H303.15a15.09,15.09,0,0,0-15,14l-2.33,33.27Z",
    style: {
      fill: "#787878"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.11,290.17H285.77a.52.52,0,0,1-.37-.16.53.53,0,0,1-.13-.38l2.33-33.28a15.64,15.64,0,0,1,15.55-14.49h30.58a15.64,15.64,0,0,1,15.55,14.49l2.33,33.28a.53.53,0,0,1-.13.38A.51.51,0,0,1,351.11,290.17Zm-64.81-1h64.28l-2.3-32.75a14.64,14.64,0,0,0-14.55-13.56H303.15a14.64,14.64,0,0,0-14.55,13.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.68,289.66l-2.33-33.27a15.1,15.1,0,0,0-15.06-14H423.72a15.09,15.09,0,0,0-15.05,14l-2.34,33.27Z",
    style: {
      fill: "#787878"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.68,290.17H406.33A.48.48,0,0,1,406,290a.5.5,0,0,1-.14-.38l2.34-33.28a15.64,15.64,0,0,1,15.55-14.49H454.3a15.64,15.64,0,0,1,15.54,14.49l2.34,33.28a.53.53,0,0,1-.13.38A.52.52,0,0,1,471.68,290.17Zm-64.81-1h64.28l-2.3-32.75a14.64,14.64,0,0,0-14.55-13.56H423.72a14.63,14.63,0,0,0-14.55,13.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.71,217.78s-5.86-4.19-9.49-2.23-11.17,23.17-12.29,27.92,5.87,8.66,10.61,10.05,14.24-1.67,16.48-3.91S310.71,217.78,310.71,217.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.39,254.37a10.6,10.6,0,0,1-3-.37c-5.06-1.49-12.15-5.55-11-10.64,1-4.1,8.59-26.12,12.54-28.25s9.77,2.09,10,2.27l.15.1.05.18c1.27,5,7.49,30,5.17,32.31C314.37,252,307.48,254.37,302.39,254.37Zm1.08-38.84a4.2,4.2,0,0,0-2,.46c-3.27,1.76-10.76,22.18-12,27.59-1,4.39,5.75,8.13,10.26,9.46,4.7,1.38,13.92-1.72,16-3.78,1.27-1.27-1.74-16.81-5.39-31.17C309.55,217.6,306.29,215.53,303.47,215.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.32,290.55c-.36-1.12-.57-1.82-.57-1.82s-4.07-21.79-5.08-23.53S331,257.79,331,257.79l-21.93-1.16s-16.41,8-16.56,9c-.08.54-3.22,13.18-6.15,24.92Z",
    style: {
      fill: "#b2b2b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351,291.05H285.73l.16-.62c5.24-21,6.09-24.59,6.14-24.87s.18-1.28,16.83-9.38l.12-.06,22.24,1.21c2.13,1,12.83,5.82,13.88,7.61s4.72,21.44,5.14,23.69h0s.21.69.56,1.77Zm-64-1h62.63l-.37-1.18c-1.64-8.78-4.32-22.2-5-23.42s-8.51-5-13.35-7.17l-21.71-1.15c-7.35,3.59-15.42,7.79-16.18,8.66C292.79,266.83,290.77,275,287,290.05Zm6-24.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.05,284a52.93,52.93,0,0,0-2.67-9.63l.95-.33a55,55,0,0,1,2.71,9.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.45,284c-.41-2,.46-4.3,1.22-6.33.28-.73.55-1.42.73-2.05l1,.28c-.2.67-.47,1.38-.75,2.13-.72,1.89-1.53,4-1.18,5.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.29,210.31s-13.06,3.62-16.68,10.63-3.87,8.59-1.82,12,7.13,9.43,11.85,11.85,19.7-1.09,19.7-1.09,4.59-2.06,6-5.68,4.72-8.71,2.54-14.15-11.84-12.93-14.86-13.78A14.53,14.53,0,0,0,321.29,210.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.9,246.1a12.81,12.81,0,0,1-5.49-.9c-4.75-2.43-9.9-8.5-12-12s-1.91-5.3,1.79-12.46,16.41-10.72,17-10.88a14.76,14.76,0,0,1,7-.25c3.3.93,13,8.69,15.2,14.08,1.88,4.71-.1,9.06-1.68,12.55-.32.7-.62,1.35-.86,2-1.51,3.77-6.11,5.87-6.31,6A76.26,76.26,0,0,1,319.9,246.1Zm5.55-35.86a16.05,16.05,0,0,0-4,.55h0c-.13,0-12.89,3.65-16.37,10.38-3.56,6.88-3.78,8.27-1.83,11.48,2.08,3.43,7.07,9.32,11.65,11.66s19.21-1.09,19.36-1.13h0s4.34-2,5.69-5.38c.25-.62.55-1.29.88-2,1.5-3.32,3.38-7.46,1.66-11.77-2.13-5.33-11.81-12.72-14.54-13.48A9,9,0,0,0,325.45,210.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.79,219.48s-6.51,4-9.85,6.34a32.48,32.48,0,0,1-7.35,3.67,4.35,4.35,0,0,0-2.33,4.85c.66,3.5,1.93,15.61,1.93,15.61l-2.27,4.92,9.68,10.68,7.68-10,.84-5.18s7-4.34,7.18-5.34,2.17-15.69,2-17.19S330.79,219.48,330.79,219.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.64,266.33,310.33,255l2.35-5.09c-.15-1.35-1.3-12.19-1.92-15.44a4.88,4.88,0,0,1,2.63-5.39,32.69,32.69,0,0,0,7.26-3.63c3.31-2.32,9.81-6.32,9.88-6.36l.32-.2.28.26c1.75,1.64,7.49,7.1,7.67,8.66s-1.91,16.71-2,17.33c-.17,1-4.51,3.88-7.21,5.57l-.82,5.07Zm-9.13-11.55,9.06,10,7.24-9.44.85-5.27.2-.12c3.14-1.95,6.69-4.43,6.95-5,.19-1.14,2.15-15.62,2-17-.09-.8-3.62-4.53-7.07-7.78-1.36.84-6.64,4.13-9.51,6.13a33.15,33.15,0,0,1-7.47,3.74,3.81,3.81,0,0,0-2,4.27c.66,3.49,1.88,15.17,1.93,15.66l0,.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.11,239.57a.49.49,0,0,1-.48-.36.5.5,0,0,1,.35-.62,9.48,9.48,0,0,0,3.06-1.46c.39-.35-.74-1.75-1.22-2.35s-.76-.95-.76-1.27c0-.49.33-3.46.37-3.8a.5.5,0,0,1,.55-.44.5.5,0,0,1,.44.55c-.14,1.3-.36,3.36-.36,3.69,0,0,.32.38.53.64.89,1.09,2.22,2.75,1.12,3.73a10.67,10.67,0,0,1-3.47,1.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.58,242.91c-1,0-2.12-.64-3.34-1.92a.5.5,0,0,1,.73-.69c1.25,1.32,2.1,1.6,2.58,1.61a.65.65,0,0,0,.56-.16.51.51,0,0,1,.71,0,.49.49,0,0,1,0,.68,1.69,1.69,0,0,1-1.23.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.12,250.36a12,12,0,0,1-3.85-1c-1.08-.73-4.23-3.14-4.23-3.14l6.17,10.63,1.07-1.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.21,257.34h0a.47.47,0,0,1-.39-.25l-6.17-10.63a.52.52,0,0,1,.1-.63.5.5,0,0,1,.64,0s3.14,2.42,4.2,3.12a11,11,0,0,0,3.62.94.49.49,0,0,1,.35.19.52.52,0,0,1,.09.38l-.83,5.18a.53.53,0,0,1-.11.24l-1.07,1.3A.5.5,0,0,1,327.21,257.34Zm-4.48-9.23,4.55,7.86.53-.64.73-4.54a10.09,10.09,0,0,1-3.54-1C324.5,249.43,323.58,248.76,322.73,248.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.88,232.67s-2.3-6.89-5-3,1.58,9.3,3.63,9.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.49,239.33c-1.2,0-2.81-1.32-3.87-3.19-1.36-2.42-1.4-4.89-.11-6.78a2.48,2.48,0,0,1,2.34-1.37c2,.28,3.36,4.09,3.5,4.52l-.94.32c-.47-1.41-1.62-3.7-2.7-3.85-.44-.07-.9.26-1.37,1-1.53,2.21-.4,4.73.15,5.72,1,1.71,2.32,2.7,3,2.68l.06,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 325.94,
    cy: 232.31,
    rx: 1.03,
    ry: 1.45,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 335.01,
    cy: 232.31,
    rx: 1.03,
    ry: 1.45,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.22,229.66a.47.47,0,0,1-.35-.15.48.48,0,0,1,0-.7,4.74,4.74,0,0,1,5.68-.56.5.5,0,1,1-.5.86,3.7,3.7,0,0,0-4.48.41A.5.5,0,0,1,323.22,229.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337,230.15a.5.5,0,0,1-.48-.37,1.47,1.47,0,0,0-.78-1,3.81,3.81,0,0,0-2.54.12.5.5,0,0,1-.38-.92,4.65,4.65,0,0,1,3.36-.1,2.47,2.47,0,0,1,1.3,1.63.51.51,0,0,1-.34.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.89 251.16 319.35 261.92 313.55 268.21 307.02 256.48 310.89 251.16",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.45,269.05l-7-12.61,4.45-6.11L320,262Zm-5.83-12.53,6,10.84,5.05-5.47-7.79-9.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "283.69 209.69 323.07 289.25 312.48 289.25 280.75 212.12",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.07,289.75H312.48a.5.5,0,0,1-.46-.31l-31.73-77.13a.49.49,0,0,1,.27-.65.49.49,0,0,1,.65.27l31.6,76.82h9.45l-39-78.84a.5.5,0,0,1,.23-.67.51.51,0,0,1,.67.23L323.52,289a.5.5,0,0,1,0,.49A.52.52,0,0,1,323.07,289.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.35 261.92 320.6 265.55 317.66 264.1 319.35 261.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.47,266.54l-4.58-2.27,2.63-3.39Zm-3-2.62,1.3.65-.55-1.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.37 260.11 326.48 268.21 332.77 257.57 328.54 254.18 322.37 260.11",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.45,269.25,321.76,260l6.75-6.48,4.91,3.93Zm-3.46-9,3.53,7,5.6-9.48-3.55-2.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.37 260.11 320.6 265.55 323.58 262.64 322.37 260.11",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.5,267.33l2.79-8.57,1.9,4Zm3-5.87-.75,2.32,1.27-1.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.52,296.86c.69-1.53,4.18-9.5,2.93-11.62-7.12-12-9.21-4-11.75-10-4.28-10.06-7.89-17.07-9.43-18.12-3-2-22.51-5.79-22.51-5.79l-23.92-.62s-20.64,8.44-22,10.32a57.83,57.83,0,0,0-8.13,13.56c-.31.76-7.44,6.46-7.76,7.22-3.36,8.17-.24,13.84.56,15.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.52,297.36H390.46a.51.51,0,0,1-.43-.23c-.71-1.1-4.08-7.06-.59-15.53.19-.45,1.31-1.45,4-3.81a44.46,44.46,0,0,0,3.73-3.43A57,57,0,0,1,405.15,261l.24-.32c1.45-1.93,20.13-9.62,22.26-10.48a.48.48,0,0,1,.2,0l23.92.62c.88.17,19.76,3.81,22.78,5.88,2.31,1.57,7.49,13.35,9.61,18.33.94,2.22,1.68,2.28,2.91,2.38,1.91.16,4.52.38,8.81,7.59,1.31,2.2-1.59,9.18-2.9,12.08A.5.5,0,0,1,492.52,297.36Zm-101.79-1H492.2c2-4.49,3.62-9.51,2.82-10.86-4-6.77-6.34-7-8-7.1-1.32-.11-2.58-.22-3.75-3-5.12-12-8.19-17.17-9.25-17.9-2.28-1.56-15.6-4.41-22.33-5.7l-23.73-.62c-7.94,3.25-20.78,8.84-21.74,10.12l-.26.33a56.16,56.16,0,0,0-7.8,13.12c-.18.42-1.11,1.27-4,3.78a44.19,44.19,0,0,0-3.77,3.46C387.26,289.52,389.86,294.89,390.73,296.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.67,294.27a.5.5,0,0,1-.5-.48c-.2-4.86-.29-9.74-.37-14.45-.06-3.24-.11-6.5-.21-9.82a.5.5,0,1,1,1,0c.1,3.32.15,6.59.21,9.83.08,4.71.17,9.58.37,14.43a.5.5,0,0,1-.48.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413,267.52a.51.51,0,0,1-.5-.49l-.06-2.48A.52.52,0,0,1,413,264a.5.5,0,0,1,.51.49l.06,2.47a.5.5,0,0,1-.49.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.1,294.31h0a.52.52,0,0,1-.47-.54l1.89-25.1a.5.5,0,0,1,1,.07l-1.89,25.1A.5.5,0,0,1,466.1,294.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.21,266.26h0a.5.5,0,0,1-.46-.54l.13-1.68a.5.5,0,0,1,1,.08l-.13,1.68A.5.5,0,0,1,468.21,266.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.34,277.73c.24,4.4-.24,13.3-.61,19.13h16c-.77-6.94-2-18.16-2.26-20.63-.37-3.62-5.24-14-5.24-14l3.12-4.12-5.62-5.87-3.62,5.62,2.87,4.74S434,270.86,434.34,277.73Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.71,297.36h-16a.48.48,0,0,1-.36-.15.49.49,0,0,1-.14-.38c.41-6.34.84-14.81.61-19.07-.34-6.33,3.68-13.64,4.54-15.13l-2.72-4.49a.51.51,0,0,1,0-.53l3.62-5.62a.51.51,0,0,1,.37-.23.5.5,0,0,1,.41.15l5.62,5.87a.5.5,0,0,1,0,.65l-2.94,3.88c.79,1.7,4.81,10.5,5.16,13.87.23,2.25,1.32,12.13,2.26,20.63a.56.56,0,0,1-.13.39A.51.51,0,0,1,449.71,297.36Zm-15.45-1h14.89c-.43-3.89-1.91-17.32-2.19-20.07-.37-3.5-5.16-13.73-5.2-13.83a.49.49,0,0,1,.05-.51l2.86-3.78-4.88-5.11-3.11,4.83,2.71,4.47a.49.49,0,0,1,0,.52c-.05.08-4.91,8.2-4.55,14.83h0C435.07,281.9,434.66,290.06,434.26,296.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "430.97 241.52 429.97 249.01 440.58 254.88 450.07 249.14 449.7 243.64 430.97 241.52",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.59,255.38a.54.54,0,0,1-.25-.06l-10.61-5.87a.49.49,0,0,1-.25-.5l1-7.5A.51.51,0,0,1,431,241l18.73,2.13a.49.49,0,0,1,.44.46l.37,5.49a.47.47,0,0,1-.24.46l-9.49,5.75A.47.47,0,0,1,440.59,255.38Zm-10.08-6.64,10.06,5.56,9-5.43-.33-4.78-17.83-2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "429.97 249.01 433.54 250.98 439.57 248.46 432.85 241.73 430.97 241.52 429.97 249.01",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.54,251.48a.54.54,0,0,1-.25-.06l-3.56-2a.49.49,0,0,1-.25-.5l1-7.5A.52.52,0,0,1,431,241l1.87.22a.49.49,0,0,1,.3.14l6.73,6.73a.46.46,0,0,1,.13.45.49.49,0,0,1-.29.36l-6,2.53A.63.63,0,0,1,433.54,251.48Zm-3-2.74,3.06,1.69,5.12-2.14-6.07-6.08-1.22-.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.23,211.89s-3.53,2.52-3.79,6.17,1.64,20.55,3.66,24.34,4.41,6.8,9.33,7.69,10.72-4,11.35-6.31,3-14,3-18.4.51-9.46-3.53-13.11-10.59-4.42-13.74-3.79S430.23,211.89,430.23,211.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.66,250.69a7.35,7.35,0,0,1-1.32-.11c-5.29-1-7.78-4.38-9.68-8-2.13-4-4-21-3.72-24.6s3.64-6.29,4-6.53a16.73,16.73,0,0,1,6.52-3.51c3.26-.65,10,.14,14.18,3.91,3.8,3.44,3.75,8.07,3.7,12.16,0,.44,0,.88,0,1.32,0,4.56-2.45,16.42-3,18.54S445.61,250.69,440.66,250.69Zm-1.8-41.91a12,12,0,0,0-2.23.19c-3,.6-6,3.27-6.07,3.29l0,0s-3.34,2.44-3.58,5.81c-.27,3.89,1.69,20.48,3.6,24.06,2.06,3.87,4.38,6.61,9,7.43s10.19-3.84,10.77-5.94c.63-2.26,3-14,3-18.27,0-.44,0-.89,0-1.34.05-4.06.09-8.26-3.37-11.4C446.83,209.82,442.18,208.78,438.86,208.78Zm-8.63,3.11h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.27,212.27c-4-3.66-10.59-4.42-13.74-3.79s-6.3,3.41-6.3,3.41-3.53,2.52-3.79,6.17a84.39,84.39,0,0,0,.93,11.72c.26.05.59-.07.59-1,0-1.51-.89-2.39.25-3.66a36.73,36.73,0,0,0,3.91-4.66,7.78,7.78,0,0,0,.75-4.16,13.59,13.59,0,0,0,6.81,2.4c4.54.5,9.46.5,10.21.63s-.25.88.89,2.39,1.63,2.27,1.76,3,.69,4.3.84,5.29a36.75,36.75,0,0,0,.42-4.66C453.8,221,454.31,215.92,450.27,212.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.38,230.54a.5.5,0,0,1-.49-.42l-.05-.28c-.2-1.27-.69-4.41-.79-5a7.86,7.86,0,0,0-1.67-2.81,2.92,2.92,0,0,1-.68-2.18v0c-.35,0-1.07-.07-2-.1-2.05-.07-5.15-.19-8.11-.52a15.77,15.77,0,0,1-6.23-1.93,7.12,7.12,0,0,1-.86,3.46,28.14,28.14,0,0,1-3.21,3.92l-.75.82a1.74,1.74,0,0,0-.32,1.89,6.48,6.48,0,0,1,.2,1.43,1.6,1.6,0,0,1-.44,1.31.91.91,0,0,1-.74.19.51.51,0,0,1-.41-.43,85.43,85.43,0,0,1-.93-11.82c.27-3.85,3.84-6.44,4-6.55a16.75,16.75,0,0,1,6.49-3.49c3.26-.65,10,.14,14.18,3.91h0c3.8,3.44,3.75,8.07,3.7,12.16,0,.44,0,.88,0,1.32a38.16,38.16,0,0,1-.42,4.73.5.5,0,0,1-.49.43ZM432.87,215.8a.47.47,0,0,1,.32.12,13.37,13.37,0,0,0,6.55,2.28c2.93.32,6,.44,8,.51,1.25,0,1.91.08,2.2.12a.88.88,0,0,1,.72,1.07,2,2,0,0,0,.48,1.52c1.15,1.54,1.71,2.36,1.85,3.24,0,.23.14.82.25,1.53,0-.3,0-.57,0-.81,0-.44,0-.89,0-1.34.05-4.06.09-8.26-3.37-11.4h0c-3.9-3.54-10.25-4.28-13.31-3.67s-6,3.27-6.07,3.29-3.38,2.47-3.62,5.84a58,58,0,0,0,.43,7.37,2.69,2.69,0,0,1,.47-.68l.76-.83a27.43,27.43,0,0,0,3.09-3.76,7.37,7.37,0,0,0,.69-3.85.49.49,0,0,1,.26-.49A.46.46,0,0,1,432.87,215.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.09,237.25a7.66,7.66,0,0,1-3.44-1.24.49.49,0,0,1-.15-.69.5.5,0,0,1,.69-.15c.55.35,2.19,1.24,3.17,1.06a7.66,7.66,0,0,0,2.57-1.17.5.5,0,0,1,.58.81,8.51,8.51,0,0,1-3,1.35A3.4,3.4,0,0,1,441.09,237.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.15,226.89a.47.47,0,0,1-.32-.12,4.24,4.24,0,0,0-5.19-.23.5.5,0,0,1-.59-.81,5.32,5.32,0,0,1,6.41.27.49.49,0,0,1,.07.7A.5.5,0,0,1,450.15,226.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.5,227.39a.5.5,0,0,1-.33-.12.51.51,0,0,1-.05-.71c2.12-2.46,5.15-1.46,6.45-.59a.5.5,0,0,1-.55.83c-.13-.08-3.07-2-5.15.42A.48.48,0,0,1,432.5,227.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.4,228.78c0,.63-.31,1.14-.69,1.14s-.69-.51-.69-1.14.31-1.13.69-1.13S436.4,228.15,436.4,228.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.93,228.78c0,.63-.31,1.14-.69,1.14s-.7-.51-.7-1.14.31-1.13.7-1.13S446.93,228.15,446.93,228.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.57,241.17a13.85,13.85,0,0,1-5.12-1,.5.5,0,0,1-.26-.66.5.5,0,0,1,.66-.26,12.68,12.68,0,0,0,9.42-.12.49.49,0,0,1,.66.24.5.5,0,0,1-.24.67A12.22,12.22,0,0,1,440.57,241.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.2,227.52s-2-1.64-2.77,1.26,3.91,6.68,3.91,6.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.34,236a.52.52,0,0,1-.32-.11c-.2-.16-4.91-4-4.08-7.2a2.59,2.59,0,0,1,1.51-2,2.5,2.5,0,0,1,2.07.49.54.54,0,0,1,.18.32l1.13,7.94a.49.49,0,0,1-.49.57Zm-2.35-8.4a.85.85,0,0,0-.23,0c-.46.16-.71.8-.85,1.32-.43,1.66,1.35,3.89,2.73,5.25l-.9-6.35A1.52,1.52,0,0,0,426,227.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.68,228s1.13-1.89,2.14.51-3.53,7.69-3.53,7.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.29,236.72a.5.5,0,0,1-.21-.05.48.48,0,0,1-.28-.53l1.38-8.2a.36.36,0,0,1,.07-.17,1.79,1.79,0,0,1,1.49-1c.62,0,1.13.55,1.54,1.51,1.1,2.61-3.13,7.65-3.61,8.21A.49.49,0,0,1,452.29,236.72Zm1.86-8.51-1,6.14c1.41-2,2.75-4.44,2.25-5.63-.28-.65-.54-.89-.69-.9S454.29,228,454.15,228.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.14,237.82s-6-.84-7.26,1.17c-1.09,1.75-.48,6.6.52,8.94a11.41,11.41,0,0,0,5,2.16c2.44.44,5.1-.56,7.24-2,.5-.71,1.21-2.5.95-6.88C447.41,237.72,445.88,237.37,441.14,237.82Zm4.51,8.19a8.1,8.1,0,0,1-4.77,1.42c-1,0-4.29-.09-5.42-1.24s-2-5.48-.9-6.89,6.51-.82,6.51-.82c4.26-.32,5.64-.08,5.83,2.41C447.24,245.45,445.65,246,445.65,246Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.64,250.69a7.21,7.21,0,0,1-1.3-.11,11.91,11.91,0,0,1-5.25-2.25.7.7,0,0,1-.15-.2c-1-2.44-1.7-7.46-.48-9.4,1.35-2.17,6.82-1.53,7.69-1.41,2.91-.27,4.7-.24,5.78.68a4.29,4.29,0,0,1,1.19,3.23c.26,4.36-.42,6.32-1,7.2a.44.44,0,0,1-.14.13A12.16,12.16,0,0,1,440.64,250.69Zm-5.83-3.08a10.68,10.68,0,0,0,4.71,2c2.67.49,5.37-.9,6.79-1.81a6.69,6.69,0,0,0,.8-3.07,2.59,2.59,0,0,1-1.21,1.73,8.62,8.62,0,0,1-5,1.49h-.11c-2.05-.06-4.55-.27-5.64-1.38a5.74,5.74,0,0,1-1.13-2.25A14.38,14.38,0,0,0,434.81,247.61Zm3.92-8.76c-1.7,0-3.34.2-3.78.76-1,1.2-.09,5.25.87,6.23s4,1,5,1.08h.11a7.79,7.79,0,0,0,4.46-1.32.39.39,0,0,1,.11-.06c.06,0,1.24-.71.94-4.63-.14-1.86-.78-2.28-5.29-1.95C440.39,238.9,439.55,238.85,438.73,238.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.55,245.37c0,.51-.73,2.06-1.63,2.06s-1.63-1.55-1.63-2.06.73-.93,1.63-.93S442.55,244.86,442.55,245.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.92,247.93c-1.29,0-2.13-1.91-2.13-2.56,0-.82.92-1.43,2.13-1.43s2.13.61,2.13,1.43C443.05,246,442.21,247.93,440.92,247.93Zm0-3c-.74,0-1.13.32-1.13.43,0,.36.63,1.56,1.13,1.56s1.13-1.2,1.13-1.56C442.05,245.26,441.66,244.94,440.92,244.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "440.58 254.88 431.47 263.37 426.6 250.51 429.72 248.01 440.58 254.88",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.47,263.87h-.11a.49.49,0,0,1-.36-.31l-4.87-12.86a.51.51,0,0,1,.16-.57l3.12-2.5a.51.51,0,0,1,.58,0l10.86,6.87a.48.48,0,0,1,.23.37.5.5,0,0,1-.15.42l-9.12,8.49A.48.48,0,0,1,431.47,263.87Zm-4.27-13.2,4.47,11.83,8.1-7.54-10-6.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "440.58 254.88 447.95 264.5 452.82 251.76 450.07 249.14 440.58 254.88",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448,265a.5.5,0,0,1-.39-.2l-7.37-9.62a.5.5,0,0,1-.1-.39.52.52,0,0,1,.24-.34l9.49-5.74a.48.48,0,0,1,.6.07l2.75,2.62a.51.51,0,0,1,.12.54l-4.87,12.73a.52.52,0,0,1-.4.32Zm-6.63-10,6.48,8.46,4.44-11.59L450,249.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "480.26 209.69 422.02 289.25 432.61 289.25 483.2 212.12",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.61,289.75H422a.51.51,0,0,1-.4-.8l58.24-79.56a.5.5,0,0,1,.81.59L423,288.75h9.33l50.45-76.91a.5.5,0,0,1,.83.55L433,289.52A.5.5,0,0,1,432.61,289.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.7,296.86h14.71c1.41-1.64,2.77-3.51,3.13-4a8.5,8.5,0,0,0,1.25-7.5,11.61,11.61,0,0,0-4.69-6.1l-3.9.78s-3.29-1.09-5.79,0-5.78,4.85-7,9.22A7,7,0,0,0,386.7,296.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.41,297.36H386.7a.55.55,0,0,1-.33-.11,7.6,7.6,0,0,1-2.47-8.08c1.29-4.54,4.73-8.42,7.31-9.55,2.39-1,5.35-.25,6-.06l3.79-.75a.43.43,0,0,1,.35.06,12,12,0,0,1,4.92,6.39,9.09,9.09,0,0,1-1.35,7.95l-.44.58c-.61.8-1.63,2.16-2.7,3.4A.52.52,0,0,1,401.41,297.36Zm-14.53-1h14.3c1-1.17,1.94-2.42,2.52-3.18l.45-.59a8,8,0,0,0,1.16-7.06,11,11,0,0,0-4.31-5.7l-3.71.74a.43.43,0,0,1-.25,0s-3.14-1-5.43,0-5.54,4.65-6.75,8.9A6.57,6.57,0,0,0,386.88,296.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.28,294.19a.49.49,0,0,1-.41-.22c-2.51-3.65-1.88-8.43,1.77-13.44a.51.51,0,0,1,.7-.11.5.5,0,0,1,.11.7c-2.4,3.29-4.65,8.09-1.76,12.29a.49.49,0,0,1-.13.69A.47.47,0,0,1,394.28,294.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.36,275.43s2.59-.64,3.45-.1a9.09,9.09,0,0,1,2.27,3.34c.43,1-.22,1.83-1.62,2.05s-3.23-1.62-3.23-1.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.23,281.23c-1.53,0-3.16-1.58-3.36-1.78a.51.51,0,0,1-.13-.24l-.86-3.66a.5.5,0,0,1,.36-.6c.47-.12,2.85-.67,3.84-.05,1.15.72,2.25,3.1,2.46,3.56a1.75,1.75,0,0,1,0,1.58,2.56,2.56,0,0,1-2,1.17A1.67,1.67,0,0,1,422.23,281.23Zm-2.55-2.39c.54.51,1.82,1.52,2.7,1.38a1.67,1.67,0,0,0,1.25-.65.75.75,0,0,0,0-.7,8.64,8.64,0,0,0-2.07-3.12,5.14,5.14,0,0,0-2.58.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "471.85 281.28 469.76 278.6 448.13 292.17 432.61 292.17 411.13 279.94 409.34 281.88 419.91 296.86 459.73 296.86 471.85 281.28",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.73,297.36H419.91a.47.47,0,0,1-.41-.21l-10.57-15a.51.51,0,0,1,.05-.63l1.79-1.94a.5.5,0,0,1,.61-.1l21.37,12.17H448l21.51-13.5a.51.51,0,0,1,.66.12l2.09,2.68a.51.51,0,0,1,0,.62l-12.12,15.58A.49.49,0,0,1,459.73,297.36Zm-39.56-1h39.31l11.73-15.08-1.57-2-21.25,13.33a.5.5,0,0,1-.26.08H432.61a.42.42,0,0,1-.24-.07l-21.14-12L410,281.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.28,296.86a32.26,32.26,0,0,1,64.41,0h5.15a37.4,37.4,0,0,0-74.71,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.84,297.36h-5.15a.49.49,0,0,1-.5-.47,31.76,31.76,0,0,0-63.41,0,.5.5,0,0,1-.5.47h-5.15a.48.48,0,0,1-.36-.15.47.47,0,0,1-.14-.37,37.9,37.9,0,0,1,75.71,0,.55.55,0,0,1-.14.37A.51.51,0,0,1,477.84,297.36Zm-4.68-1h4.15a36.9,36.9,0,0,0-73.65,0h4.15a32.76,32.76,0,0,1,65.35,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.24,272.85s-6.58,9.48-6.79,12.83,1.29,6.79,4.53,7.33,3.77-1.51,3.77-1.51,7,1.51,7.33,1.51a1.57,1.57,0,0,0,1.3-1.08,9.79,9.79,0,0,1,.75-1.73,5.59,5.59,0,0,0,1.62-1.83c.64-1.18.86-1.72.86-1.72a14,14,0,0,0,1.4-2.48,10.31,10.31,0,0,0,.22-2.16,5,5,0,0,0,1-2.91c-.11-1.51-1.62-4.2-4.75-5.93s-7.54-2.48-9.05-2.26A3.14,3.14,0,0,0,404.24,272.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,293.6a6.3,6.3,0,0,1-1.09-.1c-3.71-.62-5.17-4.51-4.95-7.86s6.29-12.22,6.85-13a3.54,3.54,0,0,1,2.53-2.2c1.63-.23,6.2.58,9.36,2.32s4.87,4.49,5,6.33a5.24,5.24,0,0,1-1,3.11,9.39,9.39,0,0,1-.23,2.13,13.3,13.3,0,0,1-1.44,2.59c-.07.16-.32.72-.86,1.72a6.13,6.13,0,0,1-1.67,1.93,9.08,9.08,0,0,0-.66,1.53,2.05,2.05,0,0,1-1.78,1.44c-.31,0-4.38-.87-7.05-1.44A3.25,3.25,0,0,1,403,293.6Zm4-22.23a3.84,3.84,0,0,0-.52,0c-1.19.17-1.76,1.61-1.76,1.62l-.06.11c-.06.1-6.5,9.41-6.7,12.58-.19,2.91,1,6.29,4.11,6.8,2.71.45,3.19-1.08,3.21-1.15a.51.51,0,0,1,.59-.35c2.61.56,6.88,1.46,7.25,1.5a1.08,1.08,0,0,0,.78-.72,10.88,10.88,0,0,1,.8-1.83.52.52,0,0,1,.16-.17,5.25,5.25,0,0,0,1.46-1.66c.62-1.13.83-1.66.84-1.67l.05-.1a13.75,13.75,0,0,0,1.33-2.33,9.75,9.75,0,0,0,.2-2,.45.45,0,0,1,.1-.3,4.49,4.49,0,0,0,.87-2.57c-.09-1.23-1.38-3.82-4.49-5.53A20.2,20.2,0,0,0,407,271.37Zm-2.75,1.48h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.23,282.51a.45.45,0,0,1-.25-.07l-8.86-5.08a.52.52,0,0,1-.19-.69.5.5,0,0,1,.69-.18l8.86,5.09a.5.5,0,0,1-.25.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.47,276.91a.42.42,0,0,1-.24-.07l-1.14-.65a.51.51,0,0,1-.19-.68.52.52,0,0,1,.69-.19l1.13.66a.49.49,0,0,1,.19.68A.5.5,0,0,1,409.47,276.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.61,287.15a.46.46,0,0,1-.23-.06L405.52,281a.51.51,0,0,1-.21-.68.5.5,0,0,1,.67-.21l11.86,6.14a.51.51,0,0,1,.21.68A.5.5,0,0,1,417.61,287.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.13,290.7a.45.45,0,0,1-.2,0l-7.77-3.44a.5.5,0,0,1,.41-.92l7.76,3.45a.49.49,0,0,1,.26.66A.52.52,0,0,1,415.13,290.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.21,286.75a.51.51,0,0,1-.2,0l-1.54-.68a.5.5,0,0,1,.41-.92l1.54.68a.51.51,0,0,1,.25.66A.5.5,0,0,1,406.21,286.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.22,296.86h14.71a7,7,0,0,0,2.32-7.56c-1.25-4.37-4.53-8.13-7-9.22s-5.79,0-5.79,0l-3.91-.78a11.67,11.67,0,0,0-4.69,6.1,8.57,8.57,0,0,0,1.25,7.5C477.45,293.35,478.8,295.22,480.22,296.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.93,297.36H480.22a.49.49,0,0,1-.38-.17c-1.07-1.24-2.1-2.6-2.71-3.4l-.44-.58a9.09,9.09,0,0,1-1.34-7.95,12.07,12.07,0,0,1,4.91-6.39.46.46,0,0,1,.36-.06l3.78.75c.67-.19,3.63-1,6,.06,2.57,1.13,6,5,7.31,9.55a7.58,7.58,0,0,1-2.48,8.08A.52.52,0,0,1,494.93,297.36Zm-14.48-1h14.29a6.57,6.57,0,0,0,2-6.92c-1.22-4.25-4.39-7.87-6.76-8.9s-5.39,0-5.42,0a.46.46,0,0,1-.26,0l-3.7-.74a11.1,11.1,0,0,0-4.32,5.7,8.07,8.07,0,0,0,1.16,7.06c.1.11.25.32.46.59C478.51,293.94,479.45,295.19,480.45,296.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.35,294.19a.52.52,0,0,1-.29-.09.5.5,0,0,1-.12-.69,7.83,7.83,0,0,0,.87-1.67.5.5,0,0,1,.94.35,9.16,9.16,0,0,1-1,1.88A.5.5,0,0,1,487.35,294.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.71,290.71h-.07a.5.5,0,0,1-.43-.56c.47-3.38-1.39-6.77-3-9a.5.5,0,1,1,.81-.59c1.75,2.4,3.73,6,3.23,9.75A.51.51,0,0,1,488.71,290.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.26,275.43s-2.59-.64-3.45-.1a9.19,9.19,0,0,0-2.26,3.34c-.43,1,.21,1.83,1.62,2.05s3.23-1.62,3.23-1.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.4,281.23a1.62,1.62,0,0,1-.31,0,2.56,2.56,0,0,1-2-1.17,1.75,1.75,0,0,1,0-1.58c.21-.46,1.31-2.84,2.46-3.56,1-.62,3.37-.07,3.83.05a.5.5,0,0,1,.37.6l-.86,3.66a.45.45,0,0,1-.14.24C462.56,279.65,460.92,281.23,459.4,281.23Zm1.49-5.62a1.65,1.65,0,0,0-.81.14,8.64,8.64,0,0,0-2.07,3.12.75.75,0,0,0,0,.7,1.64,1.64,0,0,0,1.24.65c.88.15,2.17-.87,2.71-1.38l.71-3A10.11,10.11,0,0,0,460.89,275.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.39,272.85s6.57,9.48,6.79,12.83-1.3,6.79-4.53,7.33-3.77-1.51-3.77-1.51-7,1.51-7.34,1.51a1.56,1.56,0,0,1-1.29-1.08,9.79,9.79,0,0,0-.75-1.73,5.59,5.59,0,0,1-1.62-1.83,16.66,16.66,0,0,1-.86-1.72,14,14,0,0,1-1.4-2.48,10.31,10.31,0,0,1-.22-2.16,4.9,4.9,0,0,1-1-2.91c.11-1.51,1.62-4.2,4.74-5.93s7.55-2.48,9.06-2.26A3.14,3.14,0,0,1,477.39,272.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.63,293.6a3.26,3.26,0,0,1-3-1.53c-2.66.57-6.73,1.44-7,1.44a2,2,0,0,1-1.78-1.44,9.08,9.08,0,0,0-.66-1.53,6,6,0,0,1-1.67-1.93c-.55-1-.79-1.56-.86-1.72a13.27,13.27,0,0,1-1.45-2.59,10.69,10.69,0,0,1-.23-2.13,5.24,5.24,0,0,1-1-3.11c.13-1.85,1.89-4.61,5-6.33s7.74-2.55,9.37-2.32a3.58,3.58,0,0,1,2.53,2.2c.56.81,6.63,9.68,6.85,13s-1.24,7.24-4.95,7.86A6.33,6.33,0,0,1,478.63,293.6Zm-2.75-2.6a.5.5,0,0,1,.48.37c0,.06.5,1.59,3.21,1.14,3.09-.51,4.3-3.89,4.11-6.8-.21-3.17-6.64-12.48-6.71-12.58a.37.37,0,0,1-.05-.11s-.57-1.45-1.76-1.62a18.89,18.89,0,0,0-8.75,2.21c-3.1,1.71-4.39,4.3-4.48,5.53a4.46,4.46,0,0,0,.87,2.57.51.51,0,0,1,.1.3,9.75,9.75,0,0,0,.2,2,12.84,12.84,0,0,0,1.33,2.33l.05.1a18.53,18.53,0,0,0,.84,1.67,5.29,5.29,0,0,0,1.45,1.66.44.44,0,0,1,.16.17,10.07,10.07,0,0,1,.8,1.83,1.07,1.07,0,0,0,.82.72c.33,0,4.61-.94,7.22-1.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.4,282.51a.5.5,0,0,1-.25-.93l8.86-5.09a.49.49,0,0,1,.68.18.51.51,0,0,1-.18.69l-8.86,5.08A.47.47,0,0,1,462.4,282.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.15,276.91a.5.5,0,0,1-.25-.93l1.14-.66a.51.51,0,0,1,.68.19.49.49,0,0,1-.18.68l-1.14.65A.45.45,0,0,1,472.15,276.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464,287.15a.5.5,0,0,1-.23-.95l11.86-6.14a.5.5,0,0,1,.67.21.51.51,0,0,1-.21.68l-11.86,6.14A.53.53,0,0,1,464,287.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.5,290.7a.5.5,0,0,1-.21-.95l7.77-3.45a.5.5,0,1,1,.4.92l-7.76,3.44A.51.51,0,0,1,466.5,290.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.41,286.75a.49.49,0,0,1-.45-.3.5.5,0,0,1,.25-.66l1.54-.68a.5.5,0,0,1,.66.26.51.51,0,0,1-.25.66l-1.54.68A.52.52,0,0,1,475.41,286.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.54,362.56v63.16H260.62V362.56H214.21v92.31a13,13,0,0,0,13,13h20.49a13,13,0,0,0,13-13v-4.26h22.49l10.53-6.7H473.57L487,451.56h20.58v3.31a13,13,0,0,0,13,13H541a13,13,0,0,0,13-13V362.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541,468.33H520.51A13.48,13.48,0,0,1,507,454.87v-2.81H487a.5.5,0,0,1-.24-.06l-13.29-7.59H293.79L283.38,451a.5.5,0,0,1-.27.08h-22v3.76a13.48,13.48,0,0,1-13.46,13.46H227.17a13.48,13.48,0,0,1-13.46-13.46V362.56a.5.5,0,0,1,.5-.5h46.41a.5.5,0,0,1,.5.5v62.66H507V362.56a.5.5,0,0,1,.5-.5H554a.5.5,0,0,1,.5.5v92.31A13.48,13.48,0,0,1,541,468.33ZM487.1,451.06h20.44a.5.5,0,0,1,.5.5v3.31a12.48,12.48,0,0,0,12.47,12.46H541a12.48,12.48,0,0,0,12.47-12.46V363.06H508v62.66a.5.5,0,0,1-.5.5H260.62a.5.5,0,0,1-.5-.5V363.06H214.71v91.81a12.47,12.47,0,0,0,12.46,12.46h20.49a12.47,12.47,0,0,0,12.46-12.46v-4.26a.5.5,0,0,1,.5-.5H283l10.4-6.62a.45.45,0,0,1,.27-.08H473.57a.5.5,0,0,1,.24.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.39,317.1c-1.72-3.44-14.27-16.54-16.79-19.16a4.92,4.92,0,0,1-.74-1c-3.07-5.86-29.11-73-33.68-81.49-8.37-15.62-15.1-13.27-24.05-14.41-.26,0-.52,0-.79,0l-67.94-3.43a333,333,0,0,0-33.59,0q-27.58,1.38-55.17,2.76c-15.35.78-30.14-.21-38.57,15.06-4.68,8.46-30.61,75.6-33.68,81.48a4.73,4.73,0,0,1-.74,1c-2.54,2.63-15.07,15.72-16.79,19.16-1.91,3.83-9.57,18.18-9.57,21,0,2.48,1.78,43.42,9.65,75.5A27.38,27.38,0,0,0,241,433.56a6.71,6.71,0,0,0,1.44.3h59.61a4.51,4.51,0,0,0,3.9-2.25l14.1-24.36a4.45,4.45,0,0,1,1.08-1.25A33.86,33.86,0,0,1,342,398.93h82.31A33.93,33.93,0,0,1,445.13,406a4.58,4.58,0,0,1,1.07,1.25l14.1,24.36a4.51,4.51,0,0,0,3.9,2.25h59.61a6.71,6.71,0,0,0,1.44-.3,27.38,27.38,0,0,0,19.06-19.91c7.87-32.08,9.65-73,9.65-75.5C554,335.28,546.3,320.93,544.39,317.1ZM252,286.47c12-23.44,34.45-76.3,34.45-76.3,109.59-11,193.8-.48,193.8-.48l32.54,76.78C438.63,279.3,252,286.47,252,286.47Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.81,434.36H464.2a5,5,0,0,1-4.33-2.5l-14.1-24.36a3.93,3.93,0,0,0-1-1.11,33.53,33.53,0,0,0-20.53-7H342a33.5,33.5,0,0,0-20.53,7,3.74,3.74,0,0,0-.95,1.11l-14.11,24.36a5,5,0,0,1-4.33,2.5H242.44a6,6,0,0,1-1.58-.32,28,28,0,0,1-19.41-20.27c-8.18-33.37-9.66-75.25-9.66-75.62,0-2.33,4.3-10.9,8.33-18.74l1.3-2.53c1.7-3.42,13.34-15.63,16.87-19.29a3.88,3.88,0,0,0,.65-.91c1.3-2.49,6.72-16,13-31.68,8.43-21.06,18-44.94,20.69-49.81,7.76-14.05,20.79-14.57,34.59-15.13,1.46-.06,2.92-.11,4.39-.19l37.87-1.9,17.3-.86c11.16-.56,22.48-.55,33.64,0l67.95,3.43a1.31,1.31,0,0,0,.28,0,2,2,0,0,1,.55,0c1.39.18,2.74.27,4,.36,7.08.48,13.19.89,20.39,14.31,2.56,4.77,11.83,27.86,20,48.23,6.34,15.78,12.32,30.69,13.67,33.25a3.68,3.68,0,0,0,.65.91c2.51,2.61,15.12,15.78,16.87,19.29h0l1.3,2.53c4,7.84,8.33,16.41,8.33,18.74,0,.37-1.49,42.26-9.66,75.62A27.93,27.93,0,0,1,525.39,434,6,6,0,0,1,523.81,434.36ZM342,398.43h82.31a34.57,34.57,0,0,1,21.16,7.18,5,5,0,0,1,1.19,1.39l14.1,24.36a4,4,0,0,0,3.47,2h59.61a6.08,6.08,0,0,0,1.3-.28,26.94,26.94,0,0,0,18.72-19.55c8.15-33.26,9.63-75,9.63-75.38,0-2.29-5.55-13.09-8.22-18.28-.54-1.06-1-1.94-1.3-2.55h0c-1.69-3.37-14.21-16.45-16.7-19a5.1,5.1,0,0,1-.82-1.13c-1.37-2.61-7.09-16.85-13.71-33.35-8.17-20.34-17.43-43.4-20-48.13-6.93-12.93-12.5-13.31-19.57-13.79-1.31-.09-2.68-.18-4.1-.36a1.81,1.81,0,0,0-.32,0,2,2,0,0,1-.43,0l-67.95-3.43a335,335,0,0,0-33.54,0l-17.3.86-37.87,1.9c-1.47.08-2.94.13-4.4.19-13.51.54-26.27,1.05-33.76,14.61-2.66,4.82-12.21,28.66-20.63,49.7-6.29,15.69-11.72,29.24-13,31.77a5.22,5.22,0,0,1-.82,1.15c-2.5,2.59-15,15.66-16.7,19-.3.61-.76,1.49-1.3,2.55-2.67,5.19-8.22,16-8.22,18.28,0,.37,1.48,42.12,9.63,75.38a26.93,26.93,0,0,0,18.71,19.55,6.22,6.22,0,0,0,1.31.28h59.61a4,4,0,0,0,3.47-2L319.62,407a5.11,5.11,0,0,1,1.19-1.39A34.57,34.57,0,0,1,342,398.43ZM512.8,287h0c-73.3-7.09-258.86-.07-260.73,0a.5.5,0,0,1-.44-.23.46.46,0,0,1,0-.49C263.38,263.08,285.78,210.5,286,210a.51.51,0,0,1,.41-.3c108.39-10.89,193.07-.58,193.92-.48a.51.51,0,0,1,.39.3l32.54,76.79a.5.5,0,0,1,0,.49A.51.51,0,0,1,512.8,287Zm-226-76.33c-1.75,4.09-22.49,52.63-34,75.3,13.75-.51,187.84-6.77,259.18,0l-32.1-75.75C474.42,209.5,391.78,200.13,286.81,210.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.65,433.86l-3.35,7.65H464l-2.39-7.65-15.79-27.28s-6.22-7.18-21.53-7.65-82.31,0-82.31,0a31.85,31.85,0,0,0-21.53,7.65Z",
    style: {
      fill: "#787878"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464,442H301.3a.5.5,0,0,1-.42-.22.51.51,0,0,1,0-.48l3.35-7.65,0-.05L320,406.33a.41.41,0,0,1,.1-.13,32.66,32.66,0,0,1,21.9-7.77c.63,0,67.14-.48,82.28,0,15.36.48,21.64,7.53,21.9,7.83L462,433.61a1,1,0,0,1,0,.1l2.39,7.66a.49.49,0,0,1-.07.44A.51.51,0,0,1,464,442Zm-161.94-1H463.32l-2.18-6.95-15.76-27.23h0s-6.24-6.94-21.12-7.4c-15.13-.48-81.61,0-82.28,0a31.65,31.65,0,0,0-21.15,7.48l-15.74,27.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.52,342.94s12.92,23,16.75,26.8,8.14,3.82,13.4,4.3,77.52,0,77.52,0,5.74-1,8.62-5.26,12.44-25.84,12.44-25.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.12,374.76c-11.5,0-20.71-.06-22.49-.22l-1.45-.12c-4.65-.39-8.66-.73-12.26-4.33-3.83-3.83-16.3-26-16.83-26.91a.48.48,0,0,1,0-.49.5.5,0,0,1,.44-.25H447.25a.52.52,0,0,1,.42.23.49.49,0,0,1,0,.47c-.39.88-9.62,21.62-12.48,25.92s-8.7,5.44-9,5.48C424.28,374.55,393.4,374.76,371.12,374.76Zm-51.74-31.32c2.26,4,12.9,22.59,16.25,25.94s7,3.65,11.63,4l1.46.12c5.18.47,76.75,0,77.47,0,0,0,5.49-1,8.2-5,2.52-3.78,10.41-21.32,12.09-25.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.34,346.06s10.35,18.39,13.42,21.46,6.51,3.06,10.73,3.45,62.08,0,62.08,0,4.59-.77,6.89-4.22,10-20.69,10-20.69Z",
    style: {
      fill: "#787878"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.46,371.64c-9.21,0-16.59-.05-18-.18l-1.16-.09c-3.74-.32-7-.59-9.88-3.5-3.08-3.08-13.07-20.81-13.49-21.57a.48.48,0,0,1,0-.49.5.5,0,0,1,.43-.25H434.43a.48.48,0,0,1,.42.23.49.49,0,0,1,0,.47c-.31.71-7.7,17.32-10,20.77s-7,4.4-7.23,4.43C416,371.47,391.31,371.64,373.46,371.64ZM332.2,346.56c2,3.47,10.28,18,12.91,20.61s5.57,2.89,9.26,3.2l1.16.1c4.14.38,61.45,0,62,0,0,0,4.34-.77,6.49-4,2-3,8.14-16.64,9.61-19.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.87,425.72l-2.87-7.9a12.41,12.41,0,0,0-11.92-8.19l-77.71.78a12.42,12.42,0,0,0-11.72,9.09l-1.94,6.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.87,426.22H330.71a.48.48,0,0,1-.4-.2.5.5,0,0,1-.08-.44l1.94-6.23a13,13,0,0,1,12.19-9.44l77.72-.78a12.89,12.89,0,0,1,12.39,8.52l2.87,7.9a.53.53,0,0,1-.06.46A.52.52,0,0,1,436.87,426.22Zm-105.48-1H436.16L433.53,418a11.86,11.86,0,0,0-11.44-7.86l-77.72.78a12,12,0,0,0-11.24,8.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.52 429.55 327.14 437.21 441.03 437.21 438.25 429.55 329.52 429.55",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441,437.71H327.14a.49.49,0,0,1-.4-.21.46.46,0,0,1-.08-.44L329,429.4a.5.5,0,0,1,.48-.35H438.25a.5.5,0,0,1,.47.33L441.5,437a.51.51,0,0,1-.07.46A.49.49,0,0,1,441,437.71Zm-113.21-1H440.31l-2.41-6.66h-108Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.16,297.48s2.39-18.66,6.7-18.66,23.45,5.26,23.92,9.09S554,296,550.13,297s-12,1.92-12,1.92l-1.92,7.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.25,306.59a.48.48,0,0,1-.34-.13l-9.09-8.62a.48.48,0,0,1-.16-.42c.25-2,2.59-19.1,7.2-19.1,4.09,0,23.88,5.24,24.42,9.53.51,4.1-4,8.62-8,9.64-3.42.85-10.09,1.69-11.69,1.88l-1.83,6.85a.5.5,0,0,1-.34.36Zm-8.56-9.3,8.29,7.86,1.7-6.36a.49.49,0,0,1,.43-.37c.08,0,8.14-1,11.9-1.9s7.72-5,7.28-8.55c-.41-3.24-18.67-8.65-23.43-8.65C531.08,279.32,528.62,290.23,527.69,297.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.09,297.48s-2.39-18.66-6.7-18.66-23.45,5.26-23.92,9.09,3.82,8.13,7.65,9.09,12,1.92,12,1.92l1.92,7.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,306.59h-.14a.5.5,0,0,1-.34-.36l-1.83-6.85c-1.6-.19-8.27-1-11.69-1.88-4.06-1-8.54-5.54-8-9.64.54-4.29,20.33-9.53,24.42-9.53,4.61,0,7,17.14,7.2,19.1a.48.48,0,0,1-.16.42l-9.09,8.62A.48.48,0,0,1,230,306.59Zm2.39-27.27c-4.76,0-23,5.41-23.43,8.65-.44,3.51,3.64,7.64,7.28,8.55s11.82,1.89,11.9,1.9a.5.5,0,0,1,.43.37l1.7,6.36,8.29-7.86C237.63,290.23,235.17,279.32,232.39,279.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.6,340.55s8.61,9.09,11.48,25.84c0,0-40.67-1.92-56.46-8.14s-17.71-6.7-18.19-9.57,1-23.45,7.18-26.8,12.92-2.39,19.14,2.4,13.88,12,18.19,13.4S294.6,340.55,294.6,340.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.08,366.89h0c-.41,0-40.94-2-56.62-8.17l-4-1.58c-12.4-4.86-14-5.49-14.48-8.38-.44-2.66.89-23.79,7.44-27.32,6.26-3.37,13.25-2.5,19.68,2.44,1.8,1.39,3.75,3,5.64,4.56,4.63,3.82,9.42,7.77,12.39,8.76,4.21,1.4,18.42,2.84,18.56,2.85a.51.51,0,0,1,.31.15c.09.09,8.75,9.4,11.62,26.1a.54.54,0,0,1-.12.42A.5.5,0,0,1,306.08,366.89Zm-59.86-46.5a15.33,15.33,0,0,0-7.37,1.94c-5.81,3.13-7.46,23.06-6.92,26.27.39,2.33,1.92,2.93,13.85,7.61l4,1.58c14.47,5.7,50.49,7.79,55.68,8.07-2.72-15-10.08-23.67-11.12-24.83-1.79-.19-14.49-1.52-18.58-2.88-3.15-1-8-5.06-12.72-8.94-1.88-1.55-3.82-3.16-5.61-4.54C253.74,321.82,250,320.39,246.22,320.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.73,341.94a11.22,11.22,0,1,1-11.22-11.22A11.21,11.21,0,0,1,266.73,341.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.51,353.65a11.72,11.72,0,1,1,11.72-11.71A11.72,11.72,0,0,1,255.51,353.65Zm0-22.43a10.72,10.72,0,1,0,10.72,10.72A10.72,10.72,0,0,0,255.51,331.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.75,356a5.21,5.21,0,1,1-5.2-5.21A5.2,5.2,0,0,1,286.75,356Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.55,361.66a5.71,5.71,0,1,1,5.7-5.7A5.71,5.71,0,0,1,281.55,361.66Zm0-10.41a4.71,4.71,0,1,0,4.7,4.71A4.71,4.71,0,0,0,281.55,351.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473,340.55s-8.61,9.09-11.48,25.84c0,0,40.67-1.92,56.46-8.14s17.71-6.7,18.19-9.57-1-23.45-7.18-26.8-12.92-2.39-19.14,2.4-13.88,12-18.19,13.4S473,340.55,473,340.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.52,366.89a.52.52,0,0,1-.38-.17.54.54,0,0,1-.12-.42c2.87-16.7,11.53-26,11.62-26.1a.51.51,0,0,1,.31-.15c.14,0,14.35-1.45,18.56-2.85,3-1,7.76-4.94,12.39-8.76,1.89-1.56,3.84-3.17,5.64-4.56,6.43-4.94,13.42-5.81,19.69-2.44,6.54,3.53,7.87,24.66,7.43,27.32-.48,2.89-2.07,3.52-14.48,8.38l-4,1.58c-15.69,6.18-56.22,8.15-56.63,8.17ZM473.24,341c-1,1.16-8.4,9.89-11.12,24.83,5.19-.28,41.21-2.37,55.68-8.07l4-1.58c11.93-4.68,13.47-5.28,13.85-7.61.54-3.21-1.1-23.14-6.92-26.27-6-3.23-12.41-2.41-18.6,2.34-1.79,1.38-3.73,3-5.61,4.54-4.7,3.88-9.57,7.89-12.72,8.94C487.73,339.51,475,340.84,473.24,341Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.45,341.94a11.22,11.22,0,1,0,11.22-11.22A11.21,11.21,0,0,0,503.45,341.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.67,353.65a11.72,11.72,0,1,1,11.71-11.71A11.73,11.73,0,0,1,514.67,353.65Zm0-22.43a10.72,10.72,0,1,0,10.71,10.72A10.73,10.73,0,0,0,514.67,331.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.42,356a5.21,5.21,0,1,0,5.21-5.21A5.21,5.21,0,0,0,483.42,356Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.63,361.66a5.71,5.71,0,1,1,5.71-5.7A5.72,5.72,0,0,1,488.63,361.66Zm0-10.41a4.71,4.71,0,1,0,4.71,4.71A4.72,4.72,0,0,0,488.63,351.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.29,383.14s-44.5,8.61-46.42,10-5.74,9.57-5.74,9.57l9.09-2.39s21.06,1,28.23-2.39S524.29,383.14,524.29,383.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.13,403.25a.49.49,0,0,1-.45-.71c.16-.33,3.9-8.26,5.89-9.76s42.06-9.25,46.62-10.14a.51.51,0,0,1,.51.22.47.47,0,0,1,0,.55c-.31.48-7.81,11.64-15,15s-26.79,2.51-28.39,2.45l-9,2.37Zm51-19.39c-17.78,3.45-43.6,8.73-45,9.72s-3.82,5.75-5.12,8.42l8-2.12.15,0c.21,0,21,.92,28-2.34C515,394.84,521.13,386.71,523.17,383.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.31,383.14s44.5,8.61,46.42,10,5.74,9.57,5.74,9.57l-9.09-2.39s-21.06,1-28.23-2.39S245.31,383.14,245.31,383.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.47,403.25h-.13l-9-2.37c-1.6.06-21.33.85-28.39-2.45-7.22-3.37-14.72-14.53-15-15a.47.47,0,0,1,0-.55.51.51,0,0,1,.51-.22c4.56.89,44.67,8.68,46.62,10.15s5.73,9.42,5.89,9.75a.49.49,0,0,1-.45.71Zm-9.09-3.39.13,0,8,2.12c-1.3-2.67-3.82-7.44-5.12-8.42s-27.22-6.27-45-9.72c2,2.85,8.19,11,13.93,13.66,7,3.26,27.79,2.35,28,2.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.51,348.41l-.15,0-11.81-3.94h-9.3a.5.5,0,0,1,0-1h9.38a.45.45,0,0,1,.16,0l11.88,4a.5.5,0,0,1-.16,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.87,347.85a.51.51,0,0,1-.43-.26.5.5,0,0,1,.19-.68l7.92-4.53a.46.46,0,0,1,.25-.06l10.73.12a.5.5,0,0,1,.5.51.55.55,0,0,1-.51.49l-10.59-.12-7.81,4.46A.55.55,0,0,1,299.87,347.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.2,294.89a.51.51,0,0,1-.44-.25A.51.51,0,0,1,502,294c1.23-.71,2.48-1.37,3.7-2a.5.5,0,0,1,.43.9c-1.2.58-2.42,1.23-3.63,1.93A.57.57,0,0,1,502.2,294.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.52,362.82a.52.52,0,0,1-.21,0,.49.49,0,0,1-.24-.66c8-17.61,25-49.53,48.7-65.55a.49.49,0,0,1,.69.13.5.5,0,0,1-.13.7C474.81,313.28,457.94,345,450,362.53A.5.5,0,0,1,449.52,362.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.31,372.75a.33.33,0,0,1-.17,0,.5.5,0,0,1-.3-.64s.61-1.61,1.74-4.29a.5.5,0,0,1,.66-.27.5.5,0,0,1,.26.65c-1.12,2.67-1.71,4.25-1.72,4.26A.52.52,0,0,1,445.31,372.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.13,297.47a.48.48,0,0,1-.26-.07c-2-1.21-4.06-2.34-6.13-3.37a.5.5,0,1,1,.44-.89c2.1,1,4.19,2.18,6.21,3.41a.5.5,0,0,1-.26.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.06,363.19a.5.5,0,0,1-.48-.34c-5.3-15.85-18-45.07-43.52-62.73a.5.5,0,1,1,.57-.82c25.75,17.82,38.56,47.27,43.9,63.23a.5.5,0,0,1-.31.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.55,371.61a.49.49,0,0,1-.49-.38s-.36-1.54-1.13-4.13a.5.5,0,0,1,.34-.63.51.51,0,0,1,.62.34c.78,2.62,1.14,4.18,1.15,4.19a.5.5,0,0,1-.38.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.38,320.18s-5.1-12.45-5.1-19.8",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.38,320.68a.5.5,0,0,1-.47-.31c-.21-.51-5.13-12.62-5.13-20a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5c0,7.17,5,19.49,5.06,19.61a.52.52,0,0,1-.27.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.58,319.62a100,100,0,0,0,2.83-15.85",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.58,320.12a.4.4,0,0,1-.15,0,.49.49,0,0,1-.33-.62,100.09,100.09,0,0,0,2.81-15.75.5.5,0,1,1,1,.11,99.49,99.49,0,0,1-2.85,15.93A.49.49,0,0,1,520.58,320.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.91,420.28a.53.53,0,0,1-.39-.18c-.44-.54-10.85-13.2-11.43-18.94-.61-6.12,7.62-14.66,10-15.25s40.28-8.17,41.9-8.5a.51.51,0,0,1,.59.4.49.49,0,0,1-.39.58c-.4.08-39.63,7.93-41.86,8.49-2.08.52-9.78,8.77-9.24,14.18.51,5.07,9.72,16.58,11.05,18.21l62.12-2.8,3.36-43.7a.51.51,0,0,1,.54-.46.5.5,0,0,1,.46.54L535.22,417a.5.5,0,0,1-.47.46l-62.82,2.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,420.28h0l-62.81-2.83a.5.5,0,0,1-.48-.46l-3.39-44.14a.5.5,0,0,1,.46-.54.49.49,0,0,1,.53.46l3.36,43.7,62.13,2.8c1.32-1.63,10.54-13.14,11-18.21.54-5.41-7.17-13.66-9.25-14.18s-41.46-8.41-41.85-8.49a.48.48,0,0,1-.39-.58.5.5,0,0,1,.58-.4c1.62.33,39.66,7.94,41.9,8.5s10.61,9.13,10,15.25c-.57,5.74-11,18.4-11.43,18.94A.51.51,0,0,1,297,420.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,357.92q-1.53,0-3-.12l-46.18-3.7a.5.5,0,1,1,.08-1L382,356.8a37.56,37.56,0,0,0,5.81,0l42.56-3.31a.48.48,0,0,1,.54.46.5.5,0,0,1-.46.54l-42.56,3.3Q386.46,357.92,385,357.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,362.51q-1.53,0-3-.12l-43.14-3.45a.52.52,0,0,1-.46-.54.5.5,0,0,1,.54-.46L382,361.39a38.85,38.85,0,0,0,5.81,0l41.07-3.19a.47.47,0,0,1,.54.46.5.5,0,0,1-.46.53l-41.07,3.19Q386.46,362.51,385,362.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,367.1q-1.53,0-3-.12l-40-3.21a.5.5,0,1,1,.08-1L382,366a37.56,37.56,0,0,0,5.81,0l39-3a.47.47,0,0,1,.54.46.51.51,0,0,1-.46.54l-39,3Q386.46,367.1,385,367.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.8,287h0c-73.29-7.09-258.86-.07-260.73,0a.5.5,0,0,1-.44-.23.46.46,0,0,1,0-.49C263.38,263.08,285.78,210.5,286,210a.51.51,0,0,1,.41-.3c108.39-10.89,193.07-.58,193.92-.48a.51.51,0,0,1,.39.3l32.54,76.79a.5.5,0,0,1,0,.49A.51.51,0,0,1,512.8,287Zm-226-76.33c-1.75,4.09-22.49,52.63-34,75.3,13.75-.51,187.84-6.77,259.18,0l-32.1-75.75C474.42,209.5,391.78,200.13,286.81,210.64Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarDrivingStatic);
export default __webpack_public_path__ + "static/media/CarDrivingStatic.92ad7e628c7403cbf295b1e394361c5e.svg";
export { ForwardRef as ReactComponent };